import { useEffect } from 'react';
import { AxiosError } from 'axios';
import { useGet } from 'hooks/useGet';
import { RequestStatus } from 'types/RequestStatus';

interface useGetOnMountReturn<T = any> {
	data: T;
	status: RequestStatus;
	error?: AxiosError<any> | undefined;
	getData: () => Promise<T | undefined>;
}

export const useGetOnMount = <T = any>(
	url: string,
	options: any = {},
): useGetOnMountReturn<T> => {
	const { getData, data, error, status } = useGet<T>(url, options);

	useEffect(() => {
		getData();
	}, []);

	return { data, error, status, getData };
};
